/* =============================================================================
   Akademija Starfy - od stotih posnetkov do ene fotografije
   =============================================================================
   Dva prikaza, oba na isti fiziki.

   Signal se ob skladanju sesteva PREMO SORAZMERNO s stevilom posnetkov.
   Sum je nakljucen in se sesteva s KORENOM stevila posnetkov, ker se
   nakljucna odstopanja delno iznicijo. Razmerje med njima torej raste kot

       SNR ~ koren(N)

   Iz tega sledi vse ostalo na tej strani, tudi tisto, kar zacetnike najbolj
   razocara: da za dvakrat boljso sliko potrebujes STIRIKRAT vec casa.

   Simulacija ni animacija posnetka - je izracun. Osnovna "resnica" (meglica
   in zvezde) je vedno ista, sum pa se deli s korenom N. Kar vidite, je torej
   res tisto, kar bi dobili, in ne priblizek, ki izgleda prepricljivo.
   ========================================================================== */
(function () {
  "use strict";

  var host = document.querySelector("[data-ak-sklad]");
  if (!host) return;

  var cv = host.querySelector("canvas");
  var ctx = cv.getContext("2d");
  var inN = host.querySelector("[data-in-n]");
  var outN = host.querySelector("[data-out-n]");
  var outSnr = host.querySelector("[data-out-snr]");
  var outCas = host.querySelector("[data-out-cas]");
  var verdict = host.querySelector("[data-out-verdict]");

  var W = 340, H = 240;
  cv.width = W; cv.height = H;

  /* ---- "resnica": kar je na nebu, brez suma -----------------------------
     Meglica kot dve prekrivajoci se Gaussovi lisi, nekaj zvezd in blago
     ozadje. Vrednosti so v enakih enotah kot sum, da je razmerje pomenljivo. */
  var TRUTH = new Float32Array(W * H);
  var STARS = [];
  (function zgradiResnico() {
    // ponovljivo nakljucje, da je slika ob vsakem obisku ista
    var seed = 12345;
    var rnd = function () { seed = (seed * 1103515245 + 12345) & 0x7fffffff; return seed / 0x7fffffff; };

    for (var i = 0; i < 46; i++) {
      STARS.push({ x: rnd() * W, y: rnd() * H, j: 12 + rnd() * 90, r: 0.7 + rnd() * 1.3 });
    }
    var jedra = [
      { x: W * 0.42, y: H * 0.46, sx: 34, sy: 26, a: 26 },
      { x: W * 0.56, y: H * 0.54, sx: 52, sy: 30, a: 15 },
      { x: W * 0.48, y: H * 0.50, sx: 96, sy: 62, a: 6 }
    ];
    for (var y = 0; y < H; y++) {
      for (var x = 0; x < W; x++) {
        var v = 3;                                   // sij neba
        for (var k = 0; k < jedra.length; k++) {
          var j = jedra[k];
          var dx = (x - j.x) / j.sx, dy = (y - j.y) / j.sy;
          v += j.a * Math.exp(-(dx * dx + dy * dy));
        }
        TRUTH[y * W + x] = v;
      }
    }
    STARS.forEach(function (s) {
      for (var dy = -3; dy <= 3; dy++) for (var dx = -3; dx <= 3; dx++) {
        var x = Math.round(s.x) + dx, y = Math.round(s.y) + dy;
        if (x < 0 || y < 0 || x >= W || y >= H) continue;
        TRUTH[y * W + x] += s.j * Math.exp(-(dx * dx + dy * dy) / (2 * s.r * s.r));
      }
    });
  })();

  // Gaussov sum iz dveh enakomernih (Box-Muller); ne rabimo natancnosti,
  // rabimo pravo obliko porazdelitve.
  function gauss() {
    var u = 1 - Math.random(), v = Math.random();
    return Math.sqrt(-2 * Math.log(u)) * Math.cos(2 * Math.PI * v);
  }

  var SUM_ENOTE = 11;    // sum enega posnetka v istih enotah kot signal

  function draw() {
    var n = +inN.value;
    var img = ctx.createImageData(W, H);
    var d = img.data;

    // Kljucna vrstica cele strani: sum pada s korenom stevila posnetkov.
    var sigma = SUM_ENOTE / Math.sqrt(n);

    for (var i = 0; i < W * H; i++) {
      var v = TRUTH[i] + gauss() * sigma;
      // blago raztezanje, kot ga naredi vsak program za obdelavo
      var t = Math.max(0, Math.min(1, (v - 1) / 34));
      t = Math.pow(t, 0.62);
      var p = i * 4;
      d[p] = Math.round(t * 210 + 8);
      d[p + 1] = Math.round(t * 224 + 10);
      d[p + 2] = Math.round(t * 255 + 20);
      d[p + 3] = 255;
    }
    ctx.putImageData(img, 0, 0);

    var snr = Math.sqrt(n);
    outN.textContent = n === 1 ? "1 posnetek" : n + " posnetkov";
    outSnr.textContent = snr.toFixed(1).replace(".", ",") + "×";
    var min = Math.round(n * 2);
    outCas.textContent = min < 60 ? min + " min" : (min / 60).toFixed(1).replace(".", ",") + " h";

    verdict.classList.remove("is-ok", "is-warn", "is-bad");
    if (n < 8) { verdict.classList.add("is-bad"); verdict.textContent = "Meglica je pod šumom. Toliko posnetkov pokaže, da nekaj je - ne pa kaj."; }
    else if (n < 40) { verdict.classList.add("is-warn"); verdict.textContent = "Oblika se pokaže, zrnatost ostane. Tu se večina ustavi in misli, da je kriva oprema."; }
    else { verdict.classList.add("is-ok"); verdict.textContent = "Gladko. Od tu naprej vsak nadaljnji posnetek prispeva vse manj - a še vedno prispeva."; }
  }

  inN.addEventListener("input", draw);
  draw();

  /* =======================================================================
     2. KRIVULJA DONOSA
     =======================================================================
     Isti podatek, drugacen pogled: zakaj se od nekje naprej ne splaca vec
     dodajati posnetkov v isti noci, ampak je bolje priti nazaj drugo noc. */
  var svg = host.parentElement.querySelector("[data-ak-krivulja] svg");
  if (!svg) return;
  var NS = "http://www.w3.org/2000/svg";
  var SW = 520, SH = 240, PAD = 42;
  svg.setAttribute("viewBox", "0 0 " + SW + " " + SH);
  var el = function (t, a, p) { var n = document.createElementNS(NS, t); for (var k in a) n.setAttribute(k, a[k]); (p || svg).appendChild(n); return n; };

  el("rect", { x: 0, y: 0, width: SW, height: SH, fill: "#040810", rx: 12 });
  var maxN = 100, maxS = 10;
  var X = function (n) { return PAD + (n / maxN) * (SW - PAD - 18); };
  var Y = function (s) { return SH - PAD - (s / maxS) * (SH - PAD - 22); };

  el("line", { x1: PAD, y1: SH - PAD, x2: SW - 18, y2: SH - PAD, stroke: "#3c5478", "stroke-width": "1.4" });
  el("line", { x1: PAD, y1: 22, x2: PAD, y2: SH - PAD, stroke: "#3c5478", "stroke-width": "1.4" });

  var d = "";
  for (var n = 1; n <= maxN; n++) d += (n === 1 ? "M" : "L") + X(n).toFixed(1) + " " + Y(Math.sqrt(n)).toFixed(1);
  el("path", { d: d, fill: "none", stroke: "#7fb6ff", "stroke-width": "2.2" });

  // mejniki, ki povedo, kaj krivulja pomeni v urah
  [[1, "1"], [4, "4"], [16, "16"], [64, "64"]].forEach(function (m) {
    var x = X(m[0]), y = Y(Math.sqrt(m[0]));
    el("line", { x1: x, y1: y, x2: x, y2: SH - PAD, stroke: "#233752", "stroke-width": "1", "stroke-dasharray": "3 4" });
    el("circle", { cx: x, cy: y, r: 4, fill: "#ffe9a8" });
    el("text", { x: x, y: y - 12, "text-anchor": "middle", fill: "#ffe9a8", "font-size": "11", "font-weight": "600" })
      .textContent = Math.sqrt(m[0]) + "×";
    el("text", { x: x, y: SH - PAD + 16, "text-anchor": "middle", fill: "#6b80a3", "font-size": "10" }).textContent = m[1];
  });
  el("text", { x: SW / 2, y: SH - 8, "text-anchor": "middle", fill: "#9fb0c9", "font-size": "11" })
    .textContent = "število posnetkov";
  el("text", { x: 12, y: 16, fill: "#9fb0c9", "font-size": "11" }).textContent = "izboljšanje razmerja signal/šum";
})();
